import script from "./InstitucionPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstitucionPanel.vue?vue&type=script&setup=true&lang=ts"

import "./InstitucionPanel.vue?vue&type=style&index=0&id=30c739c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c739c6"]])

export default __exports__